import React from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaInfoCircle } from 'react-icons/fa';
import { IoAddSharp } from 'react-icons/io5';
import { RiRefreshLine } from 'react-icons/ri';

const selectTheme = (theme) => ({ ...theme, borderRadius: 5, padding: 9 });
const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
    color: state.isFocused ? '#000 ' : '#000',
    ':hover': { backgroundColor: '#F5F5F5', color: '#000 ' },
  }),
};

const ReadOnlyField = ({ label, value }) => (
  <div className="d-flex">
    <label className="form-label pt-2 start">{label}</label>
    <input type="text" className="p-2 form-control w-75" value={value || ''} readOnly disabled />
  </div>
);

const SelectionPanel = ({
  date,
  onDateChange,
  releaseTypeOptions,
  releaseType,
  onReleaseTypeChange,
  releaseTypeLocked,
  propertyOptions,
  property,
  onPropertyChange,
  unitOptions,
  loadingUnits,
  unitNo,
  onUnitChange,
  unitRefNo,
  leaseReservedOnly,
  onToggleLeaseReserved,
  addEntireGroup,
  onToggleEntireGroup,
  groupId,
  status,
  unitClass,
  leaseNo,
  isRenewedLease,
  canAdd,
  onAdd,
  onReset,
}) => (
  <div className="border-box2 p-3">
    <div className="form-group grid-contain">
      <div className="d-flex align-items-center gap-2">
        <input type="checkbox" id="leaseReservedOnly" checked={leaseReservedOnly} onChange={(e) => onToggleLeaseReserved(e.target.checked)} />
        <label htmlFor="leaseReservedOnly" className="form-label mb-0">
          Lease Reserved units
        </label>
      </div>
      <div className="d-flex align-items-center gap-2">
        <label className="form-label mb-0 pt-1">Date</label>
        <DatePicker todayButton="Today" selected={date} onChange={onDateChange} dateFormat="dd-MMM-yyyy" className="p-2 form-control" />
      </div>
      <div />

      <div className="d-flex">
        <label className="form-label pt-2 start">Property</label>
        <Select
          className="p-0 w-100"
          theme={selectTheme}
          menuPortalTarget={document.body}
          styles={selectStyles}
          value={property}
          onChange={onPropertyChange}
          options={propertyOptions}
          isClearable
          placeholder="Select Property"
        />
      </div>
      <div className="d-flex">
        <label className="form-label pt-2 start">Unit No</label>
        <Select
          className="p-0 w-100"
          theme={selectTheme}
          menuPortalTarget={document.body}
          styles={selectStyles}
          value={unitNo}
          onChange={onUnitChange}
          options={unitOptions}
          isDisabled={!property || loadingUnits}
          isLoading={loadingUnits}
          isClearable
          placeholder="Select Unit"
        />
      </div>
      <div className="d-flex">
        <label className="form-label pt-2 start">Release Type</label>
        <Select
          className="p-0 w-100"
          theme={selectTheme}
          menuPortalTarget={document.body}
          styles={selectStyles}
          value={releaseType}
          onChange={onReleaseTypeChange}
          options={releaseTypeOptions}
          isDisabled={releaseTypeLocked}
        />
      </div>

      <ReadOnlyField label="Unit Ref No" value={unitRefNo} />
      <div className="d-flex">
        <label className="form-label pt-2 start">Status</label>
        <input type="text" className="p-2 form-control w-75" value={status || ''} readOnly disabled />
      </div>
      <div className="d-flex">
        <label className="form-label pt-2 start">Unit Class</label>
        <input type="text" className="p-2 form-control w-75" value={unitClass || ''} readOnly disabled />
      </div>
      <div className="d-flex">
        <label className="form-label pt-2 start">Lease No</label>
        <input type="text" className="p-2 form-control w-75" value={leaseNo || ''} readOnly disabled />
      </div>
      {groupId ? (
        <div className="d-flex align-items-center gap-2">
          <input type="checkbox" id="addEntireGroup" checked={addEntireGroup} onChange={(e) => onToggleEntireGroup(e.target.checked)} />
          <label htmlFor="addEntireGroup" className="form-label mb-0">
            Add entire group of {groupId}
          </label>
        </div>
      ) : (
        <div />
      )}
    </div>

    {isRenewedLease && (
      <div className="d-flex align-items-center gap-2 mt-2 p-2" style={{ background: '#FFF8E1', borderRadius: 6 }}>
        <FaInfoCircle color="#F9A825" />
        <span>This is a renewed lease.</span>
      </div>
    )}

    <div className="d-flex justify-content-end gap-2 mt-3">
      <div onClick={onReset} className="mainbtnRed flex-end gap-2">
        <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
        <div className="center">Reset</div>
      </div>
      <div onClick={canAdd ? onAdd : undefined} className={`mainbtn flex-end gap-2 ${!canAdd ? 'disabled' : ''}`} style={!canAdd ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}>
        <IoAddSharp color="#fff" className="center mt-1 mx-2" />
        <div className="center">Add</div>
      </div>
    </div>
  </div>
);

export default SelectionPanel;
